export const FooterLoader = () => <div className="footer-loader" />;
